export default "__VITE_ASSET__ByzwaWkW__"